import { GENERIC_ERROR } from "../reducer/notification";

/* eslint-disable no-param-reassign */
const failure = (dispatch: any, type: string, input: any) => (payload: any) => {
    dispatch({
        type,
        ...input,
        data: payload?.data,
    });

    dispatch({
        type: GENERIC_ERROR,
        message: payload?.response?.data?.length ? payload.response.data : payload?.response?.statusText ?? 'Something went wrong!',
    });

    if (payload.onFailure) payload.onFailure(payload);
};

export default failure;
